module.exports = __webpack_public_path__ + "static/media/contacts-book.bb67f053.svg";